import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/** <cadence-toggle ?checked label="…"> emits `change` with boolean. */
@customElement('cadence-toggle')
export class CadenceToggle extends LitElement {
  @property({ type: Boolean }) checked = false;
  @property() label = '';

  static styles = css`
    :host { display: inline-block; }
    label { display: inline-flex; align-items: center; gap: 10px; cursor: pointer; font-size: 0.9rem; }
    .track {
      width: 40px; height: 22px; border-radius: 999px; background: var(--color-border);
      position: relative; transition: background 0.15s;
    }
    .track.on { background: var(--color-primary); }
    .knob {
      position: absolute; top: 2px; left: 2px; width: 18px; height: 18px; border-radius: 50%;
      background: #fff; transition: transform 0.15s; box-shadow: 0 1px 3px rgba(0,0,0,0.3);
    }
    .track.on .knob { transform: translateX(18px); }
    input { position: absolute; opacity: 0; width: 0; height: 0; }
  `;

  private toggle() {
    this.checked = !this.checked;
    this.dispatchEvent(new CustomEvent('change', { detail: this.checked, bubbles: true, composed: true }));
  }

  render() {
    return html`
      <label>
        <span class="track ${this.checked ? 'on' : ''}" aria-hidden="true">
          <span class="knob"></span>
        </span>
        ${this.label ? html`<span>${this.label}</span>` : ''}
        <input type="checkbox" role="switch" .checked=${this.checked} @change=${this.toggle} />
      </label>
    `;
  }
}
